// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteApiV1PredictionPostData, DeleteApiV1PredictionPostResponses, GetApiV1AppDownloadLinkData, GetApiV1AppDownloadLinkResponses, GetApiV1ArticleTypeDetailData, GetApiV1ArticleTypeDetailResponses, GetApiV1ArticleTypeListData, GetApiV1ArticleTypeListResponses, GetApiV1ArticleTypeSearchData, GetApiV1ArticleTypeSearchResponses, GetApiV1ArticleTypeUserData, GetApiV1ArticleTypeUserResponses, GetApiV1AuthOssStsData, GetApiV1AuthOssStsResponses, GetApiV1BannersListData, GetApiV1BannersListResponses, GetApiV1BbContentData, GetApiV1BbContentResponses, GetApiV1BbLotteryResultData, GetApiV1BbLotteryResultResponses, GetApiV1BbLotteryYearData, GetApiV1BbLotteryYearResponses, GetApiV1BlockListData, GetApiV1BlockListResponses, GetApiV1CaptchaData, GetApiV1CaptchaResponses, GetApiV1CommentHotsData, GetApiV1CommentHotsResponses, GetApiV1CommentListData, GetApiV1CommentListResponses, GetApiV1CommentPopularData, GetApiV1CommentPopularResponses, GetApiV1CommunityDetailData, GetApiV1CommunityDetailResponses, GetApiV1CommunityForumPublishCheckData, GetApiV1CommunityForumPublishCheckResponses, GetApiV1CommunityForumPublishSuggestData, GetApiV1CommunityForumPublishSuggestResponses, GetApiV1CommunityLastContentData, GetApiV1CommunityLastContentResponses, GetApiV1CommunityListData, GetApiV1CommunityListResponses, GetApiV1CompeteTypeListData, GetApiV1CompeteTypeListResponses, GetApiV1ContentCollectListData, GetApiV1ContentCollectListResponses, GetApiV1ExternalLinksListData, GetApiV1ExternalLinksListResponses, GetApiV1FansRankingData, GetApiV1FansRankingResponses, GetApiV1ForumAnnouncementsData, GetApiV1ForumAnnouncementsResponses, GetApiV1ForumAwardRankingData, GetApiV1ForumAwardRankingFooterData, GetApiV1ForumAwardRankingFooterResponses, GetApiV1ForumAwardRankingResponses, GetApiV1ForumAwardRankingYearPeriodData, GetApiV1ForumAwardRankingYearPeriodResponses, GetApiV1ForumBannersData, GetApiV1ForumBannersResponses, GetApiV1ForumMyPowerData, GetApiV1ForumMyPowerResponses, GetApiV1ForumPowerRankingData, GetApiV1ForumPowerRankingResponses, GetApiV1KeywordRankingsData, GetApiV1KeywordRankingsResponses, GetApiV1LiveTopAdData, GetApiV1LiveTopAdResponses, GetApiV1LotteryAocaiLiveData, GetApiV1LotteryAocaiLiveResponses, GetApiV1LotteryDetail49208Data, GetApiV1LotteryDetail49208Responses, GetApiV1LotteryHkmarksixLiveData, GetApiV1LotteryHkmarksixLiveResponses, GetApiV1LotteryLiveSourceData, GetApiV1LotteryLiveSourceResponses, GetApiV1LotterySearch49208Data, GetApiV1LotterySearch49208Responses, GetApiV1LotteryTk118H5GuessDetailData, GetApiV1LotteryTk118H5GuessDetailResponses, GetApiV1LotteryTk118H5GuessListPeriodData, GetApiV1LotteryTk118H5GuessListPeriodResponses, GetApiV1LotteryTk118H5GuessListYearData, GetApiV1LotteryTk118H5GuessListYearResponses, GetApiV1LotteryYearsData, GetApiV1LotteryYearsResponses, GetApiV1NoticesListData, GetApiV1NoticesListResponses, GetApiV1NotificationsData, GetApiV1NotificationsResponses, GetApiV1PredictionBoardsData, GetApiV1PredictionBoardsResponses, GetApiV1PredictionDetailData, GetApiV1PredictionDetailResponses, GetApiV1PredictionListData, GetApiV1PredictionListResponses, GetApiV1PredictionMyData, GetApiV1PredictionMyResponses, GetApiV1PredictionTypesData, GetApiV1PredictionTypesResponses, GetApiV1PredictionUserData, GetApiV1PredictionUserFansData, GetApiV1PredictionUserFansResponses, GetApiV1PredictionUserFollowsData, GetApiV1PredictionUserFollowsResponses, GetApiV1PredictionUserResponses, GetApiV1SiteConfigData, GetApiV1SiteConfigResponses, GetApiV1TreasureSitesData, GetApiV1TreasureSitesResponses, GetApiV1TukuCategoriesData, GetApiV1TukuCategoriesResponses, GetApiV1TukuImagesDetailByPeriodData, GetApiV1TukuImagesDetailByPeriodResponses, GetApiV1TukuImagesDetailData, GetApiV1TukuImagesDetailResponses, GetApiV1TukuImagesHistoryData, GetApiV1TukuImagesHistoryResponses, GetApiV1TukuImagesLatestData, GetApiV1TukuImagesLatestResponses, GetApiV1TukuListData, GetApiV1TukuListResponses, GetApiV1TukuPictureSeriesByRegionData, GetApiV1TukuPictureSeriesByRegionResponses, GetApiV1TukuPictureSeriesByRegionSearchData, GetApiV1TukuPictureSeriesByRegionSearchResponses, GetApiV1TukuPictureTypesByRegionData, GetApiV1TukuPictureTypesByRegionPeriodsData, GetApiV1TukuPictureTypesByRegionPeriodsResponses, GetApiV1TukuPictureTypesByRegionResponses, GetApiV1TukuPictureTypesByRegionYearsData, GetApiV1TukuPictureTypesByRegionYearsResponses, GetApiV1TukuRecommendData, GetApiV1TukuRecommendResponses, GetApiV1TukuSearchData, GetApiV1TukuSearchResponses, GetApiV1TukuSimilarData, GetApiV1TukuSimilarResponses, GetApiV1TukuVoteSummaryData, GetApiV1TukuVoteSummaryResponses, GetApiV1UserByIdProfileData, GetApiV1UserByIdProfileResponses, GetApiV1UserCommentListData, GetApiV1UserCommentListResponses, GetApiV1UserFanData, GetApiV1UserFanResponses, GetApiV1UserFollowersData, GetApiV1UserFollowersResponses, GetApiV1UserFollowingsData, GetApiV1UserFollowingsResponses, GetApiV1UserFollowListData, GetApiV1UserFollowListResponses, GetApiV1UserLikeData, GetApiV1UserLikeListData, GetApiV1UserLikeListResponses, GetApiV1UserLikeResponses, PostApiV1AssetUploadSignData, PostApiV1AssetUploadSignResponses, PostApiV1BbVoteData, PostApiV1BbVoteResponses, PostApiV1BlockAddData, PostApiV1BlockAddResponses, PostApiV1BlockRemoveData, PostApiV1BlockRemoveResponses, PostApiV1CaptchaVerifyData, PostApiV1CaptchaVerifyResponses, PostApiV1CheckCodeData, PostApiV1CheckCodeResponses, PostApiV1CheckRegisterInfoData, PostApiV1CheckRegisterInfoResponses, PostApiV1CommentData, PostApiV1CommentLikeData, PostApiV1CommentLikeResponses, PostApiV1CommentResponses, PostApiV1CommunityForumEditData, PostApiV1CommunityForumEditResponses, PostApiV1CommunityForumPublishData, PostApiV1CommunityForumPublishResponses, PostApiV1ContentCollectData, PostApiV1ContentCollectResponses, PostApiV1DelNotificationsData, PostApiV1DelNotificationsResponses, PostApiV1ForumCommentLikeData, PostApiV1ForumCommentLikeResponses, PostApiV1LoginData, PostApiV1LoginRegisterData, PostApiV1LoginRegisterResponses, PostApiV1LoginResponses, PostApiV1LogoutData, PostApiV1LogoutResponses, PostApiV1LotteryVideoListData, PostApiV1LotteryVideoListResponses, PostApiV1ObjectSupportData, PostApiV1ObjectSupportResponses, PostApiV1PredictionPostData, PostApiV1PredictionPostResponses, PostApiV1PredictionShareData, PostApiV1PredictionShareResponses, PostApiV1PredictionThumbUpData, PostApiV1PredictionThumbUpResponses, PostApiV1RegisterData, PostApiV1RegisterResponses, PostApiV1SendCodeData, PostApiV1SendCodeResponses, PostApiV1TukuVoteData, PostApiV1TukuVoteResponses, PostApiV1UserAvatarData, PostApiV1UserAvatarResponses, PostApiV1UserChangeBindPhoneCheckOldData, PostApiV1UserChangeBindPhoneCheckOldResponses, PostApiV1UserChangeBindPhoneData, PostApiV1UserChangeBindPhoneResponses, PostApiV1UserChangePasswordData, PostApiV1UserChangePasswordResponses, PostApiV1UserCheckPasswordData, PostApiV1UserCheckPasswordResponses, PostApiV1UserFollowData, PostApiV1UserFollowResponses, PostApiV1UserModifyPasswordData, PostApiV1UserModifyPasswordResponses, PostApiV1UserSetPasswordData, PostApiV1UserSetPasswordResponses, PutApiV1UserNicknameData, PutApiV1UserNicknameResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * 寻宝站点列表（网址大全 / 担保平台）
 *
 * 只返回上架数据，按展示顺序排序，不分页；免鉴权。
 * board=1 网址大全（category 1=澳彩 2=港彩），board=2 担保平台（category 固定 0）。
 * 澳彩/港彩切换与关键词搜索可前端本地过滤，接口也支持 category / keyword 参数。
 *
 */
export const getApiV1TreasureSites = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TreasureSitesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TreasureSitesResponses, unknown, ThrowOnError>({ url: '/api/v1/treasure/sites', ...options });

/**
 * 图库类型列表
 *
 * 返回指定地区的图库类型列表。传 group_by=letter 时按首字母分组， data.list_by_letter 为 [{letter, items[]}] 结构。 不传 group_by 时直接返回扁平列表。 color=1 彩色 / 2 黑白；year 指定年份。
 *
 */
export const getApiV1TukuPictureTypesByRegion = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TukuPictureTypesByRegionData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TukuPictureTypesByRegionResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/picture-types/{region}', ...options });

/**
 * 图库年份列表
 *
 * 返回指定地区有图库数据的年份列表，data.list 为年份整数数组。
 */
export const getApiV1TukuPictureTypesByRegionYears = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TukuPictureTypesByRegionYearsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TukuPictureTypesByRegionYearsResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/picture-types/{region}/years', ...options });

/**
 * 图库期数列表
 *
 * 返回指定地区+年份的期数列表，data.list 为 TukuImages 数组，每项含 period、name 字段。
 */
export const getApiV1TukuPictureTypesByRegionPeriods = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TukuPictureTypesByRegionPeriodsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TukuPictureTypesByRegionPeriodsResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/picture-types/{region}/periods', ...options });

/**
 * 图库图片详情（按地区+年份+期号）
 *
 * 按地区+pictureTypeId 查询图片详情。 可只传 pictureTypeId 取当年最新一期，或传 pictureTypeId+year+period 精确查询。 返回 current（当前期）、pre（上一期）、next（下一期）及 has_pre/has_next 标志。
 *
 */
export const getApiV1TukuImagesDetailByPeriod = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TukuImagesDetailByPeriodData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TukuImagesDetailByPeriodResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/images/detail-by-period', ...options });

/**
 * 图库系列列表
 *
 * 返回指定地区的图库系列列表，data 直接为系列对象数组（不含 list 包装层）。
 */
export const getApiV1TukuPictureSeriesByRegion = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TukuPictureSeriesByRegionData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TukuPictureSeriesByRegionResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/picture-series/{region}', ...options });

/**
 * 图库系列搜索
 *
 * 按系列 ID 搜索图库，支持年份、关键字、分页、颜色筛选。 返回 data.list（PictureTypeItem 数组）和 data.color。
 *
 */
export const getApiV1TukuPictureSeriesByRegionSearch = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TukuPictureSeriesByRegionSearchData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TukuPictureSeriesByRegionSearchResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/picture-series/{region}/search', ...options });

/**
 * 图库推荐流
 *
 * 首页/图库下滑推荐，分页，可选 region 筛选地区。data.list 为推荐图库数组。
 */
export const getApiV1TukuRecommend = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1TukuRecommendData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1TukuRecommendResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/recommend', ...options });

/**
 * 类似图纸推荐
 *
 * 根据当前图库 ID 返回同系列优先 + 最新更新的类似图纸列表，已排除自身并去重。 data.result_list 为合并后的最终列表，前端直接渲染； data.series_list 为同系列列表；data.latest_list 为最新更新列表。
 *
 */
export const getApiV1TukuSimilar = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TukuSimilarData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TukuSimilarResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/similar', ...options });

/**
 * 图库 12 生肖投票汇总
 *
 * 查询指定图库在指定年、期的 12 生肖投票聚合结果，以及当期是否已开奖。 animals 固定返回 12 项（animal_id 1-12 分别对应 鼠/牛/虎/兔/龙/蛇/马/羊/猴/鸡/狗/猪）， 即使该期还没有任何人投票也会返回 12 项空壳（vote_count=0, rate="0.00"）， 前端可直接按顺序渲染。可选鉴权：携带 Bearer Token 时返回 my_animal_id 为当前用户本期已投的生肖； 未登录或未投过则 my_animal_id=0。
 *
 */
export const getApiV1TukuVoteSummary = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TukuVoteSummaryData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TukuVoteSummaryResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/vote/summary', ...options });

/**
 * 图库 12 生肖投票/改票
 *
 * 对指定图库的当期投票（12 生肖选一）。每个用户在 (tuku_id, year, period) 维度下唯一一票： 首次提交为新增投票；再次提交不同 animal_id 为改票（覆盖上一次选择）； 再次提交相同 animal_id 返回错误「您已经投过该选项」。不提供取消投票入口。 已开奖期禁止投票/改票，返回业务错误码 100700（ISSUE_CLOSED），message「本期已开奖，无法投票」。 未登录由鉴权中间件返回 HTTP 401。投票成功后返回与 summary 完全一致的结构，前端可直接刷新 UI。
 *
 */
export const postApiV1TukuVote = <ThrowOnError extends boolean = false>(options: Options<PostApiV1TukuVoteData, ThrowOnError>) => (options.client ?? client).post<PostApiV1TukuVoteResponses, unknown, ThrowOnError>({
    url: '/api/v1/tuku/vote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 图库分类列表
 *
 * 前台可用的图库分类列表
 */
export const getApiV1TukuCategories = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1TukuCategoriesData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1TukuCategoriesResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/categories', ...options });

/**
 * 图库列表
 *
 * 按分类分页拉取图库列表
 */
export const getApiV1TukuList = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1TukuListData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1TukuListResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/list', ...options });

/**
 * 图库搜索
 *
 * 按名称模糊搜索图库（不分页，返回匹配的图库列表）。name 为必填，缺失返回 HTTP 400。
 */
export const getApiV1TukuSearch = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TukuSearchData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TukuSearchResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/search', ...options });

/**
 * 最新图片
 *
 * 返回各图库的最新一期图片，data 为 TukuImages 数组（注意：直接是数组，不是 list 包装）
 */
export const getApiV1TukuImagesLatest = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1TukuImagesLatestData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1TukuImagesLatestResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/images/latest', ...options });

/**
 * 历史图片
 *
 * 按 tuku_id 拉取指定期数之前的历史图片列表（不含 period 当期），分页返回
 */
export const getApiV1TukuImagesHistory = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TukuImagesHistoryData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TukuImagesHistoryResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/images/history', ...options });

/**
 * 图库图片详情
 *
 * 按 tuku_id + period 查询指定图库期数的图片详情。 响应结构与 /api/v1/tuku/images/detail-by-period 相同（current/has_pre/pre/has_next/next 等）。
 *
 */
export const getApiV1TukuImagesDetail = <ThrowOnError extends boolean = false>(options: Options<GetApiV1TukuImagesDetailData, ThrowOnError>) => (options.client ?? client).get<GetApiV1TukuImagesDetailResponses, unknown, ThrowOnError>({ url: '/api/v1/tuku/images/detail', ...options });

/**
 * 港彩最新开奖（直播）
 *
 * 返回港彩最新一期开奖结果及下期开奖信息
 */
export const getApiV1LotteryHkmarksixLive = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1LotteryHkmarksixLiveData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1LotteryHkmarksixLiveResponses, unknown, ThrowOnError>({ url: '/api/v1/lottery/hkmarksix-live', ...options });

/**
 * 澳彩最新开奖（直播）
 *
 * 返回澳彩最新一期开奖结果及下期开奖信息
 */
export const getApiV1LotteryAocaiLive = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1LotteryAocaiLiveData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1LotteryAocaiLiveResponses, unknown, ThrowOnError>({ url: '/api/v1/lottery/aocai-live', ...options });

/**
 * 获取直播顶部广告位
 *
 * C 端进入直播间 / 直播列表页时拉取。enabled=false 时前端不渲染该广告位
 */
export const getApiV1LiveTopAd = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1LiveTopAdData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1LiveTopAdResponses, unknown, ThrowOnError>({ url: '/api/v1/live-top-ad', ...options });

/**
 * 获取开奖直播视频源
 *
 * C 端进入直播页时拉取港彩 / 澳彩当前 HTTP-FLV 直播地址（hk/macau），运营在后台可热改。 某字段为空字符串表示该彩种暂无可用源。到规定时间后若播放不出来，应重新请求该接口获取最新地址。
 */
export const getApiV1LotteryLiveSource = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1LotteryLiveSourceData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1LotteryLiveSourceResponses, unknown, ThrowOnError>({ url: '/api/v1/lottery-live-source', ...options });

/**
 * 开奖年份列表
 *
 * 返回指定地区有历史开奖记录的年份列表
 */
export const getApiV1LotteryYears = <ThrowOnError extends boolean = false>(options: Options<GetApiV1LotteryYearsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1LotteryYearsResponses, unknown, ThrowOnError>({ url: '/api/v1/lottery/years', ...options });

/**
 * 历史开奖记录列表
 *
 * 按地区和年份查询历史开奖记录，支持分页
 */
export const getApiV1LotterySearch49208 = <ThrowOnError extends boolean = false>(options: Options<GetApiV1LotterySearch49208Data, ThrowOnError>) => (options.client ?? client).get<GetApiV1LotterySearch49208Responses, unknown, ThrowOnError>({ url: '/api/v1/lottery/search-49208', ...options });

/**
 * 单期开奖详情
 *
 * 按记录 ID 查询单期开奖详情，包含开奖号码、特码分析(desc)、 正码分析列表(detailList)、第期推荐(recommend)。 id = year * 10000 + period * 10 + lotteryTypeNum（hk=1, aocai=2）
 *
 */
export const getApiV1LotteryDetail49208 = <ThrowOnError extends boolean = false>(options: Options<GetApiV1LotteryDetail49208Data, ThrowOnError>) => (options.client ?? client).get<GetApiV1LotteryDetail49208Responses, unknown, ThrowOnError>({ url: '/api/v1/lottery/detail-49208', ...options });

/**
 * 发送验证码
 *
 * 按 scene 发送短信验证码。 scene: sms_login=短信登录, register=注册, change_password=修改密码。 测试/本地环境无需真实短信，直接用万能验证码 9527 即可。
 *
 */
export const postApiV1SendCode = <ThrowOnError extends boolean = false>(options: Options<PostApiV1SendCodeData, ThrowOnError>) => (options.client ?? client).post<PostApiV1SendCodeResponses, unknown, ThrowOnError>({
    url: '/api/v1/send-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 短信验证码登录/注册
 *
 * 当手机号未注册时自动注册并登录，已注册时直接登录。 测试/本地环境万能验证码为 9527。
 *
 */
export const postApiV1LoginRegister = <ThrowOnError extends boolean = false>(options: Options<PostApiV1LoginRegisterData, ThrowOnError>) => (options.client ?? client).post<PostApiV1LoginRegisterResponses, unknown, ThrowOnError>({
    url: '/api/v1/login-register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 密码登录
 */
export const postApiV1Login = <ThrowOnError extends boolean = false>(options: Options<PostApiV1LoginData, ThrowOnError>) => (options.client ?? client).post<PostApiV1LoginResponses, unknown, ThrowOnError>({
    url: '/api/v1/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 校验验证码并获取 ticket
 *
 * 校验通过后返回 ticket，用于 change_password 等需要 ticket 的接口。 测试/本地环境验证码填 9527 即可。
 *
 */
export const postApiV1CheckCode = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CheckCodeData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CheckCodeResponses, unknown, ThrowOnError>({
    url: '/api/v1/check-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 重置密码
 *
 * 通过验证码 ticket + 新密码重置密码，无需登录。 需先调 send-code(scene=change_password) 再调 check-code 获取 ticket。
 *
 */
export const postApiV1UserChangePassword = <ThrowOnError extends boolean = false>(options: Options<PostApiV1UserChangePasswordData, ThrowOnError>) => (options.client ?? client).post<PostApiV1UserChangePasswordResponses, unknown, ThrowOnError>({
    url: '/api/v1/user/change_password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 设置密码
 *
 * 短信登录后未设密码时可调用，设置后可用密码登录。需要 Authorization header。
 *
 */
export const postApiV1UserSetPassword = <ThrowOnError extends boolean = false>(options: Options<PostApiV1UserSetPasswordData, ThrowOnError>) => (options.client ?? client).post<PostApiV1UserSetPasswordResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/set_password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 关注/取消关注
 *
 * 已关注则取消，未关注则添加
 */
export const postApiV1UserFollow = <ThrowOnError extends boolean = false>(options: Options<PostApiV1UserFollowData, ThrowOnError>) => (options.client ?? client).post<PostApiV1UserFollowResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/follow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 点赞/取消点赞
 *
 * 根据 id 和 type 切换点赞状态。type：4=资料大全,16=天线宝宝,8=幽默竞猜,1=六合图库。 六合论坛主帖点赞请使用 /api/v1/forum/comment/like 接口。
 *
 */
export const getApiV1UserLike = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserLikeData, ThrowOnError>) => (options.client ?? client).get<GetApiV1UserLikeResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/like',
    ...options
});

/**
 * 我的点赞列表
 *
 * 查询当前用户对某类型内容的点赞列表。
 * type=3（六合论坛）从 comment 表读 forum/comment/like 写入的论坛点赞，
 * 其他 type 从 user_like 表读。
 *
 */
export const getApiV1UserLikeList = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserLikeListData, ThrowOnError>) => (options.client ?? client).get<GetApiV1UserLikeListResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/like/list',
    ...options
});

/**
 * 获取通知列表
 */
export const getApiV1NoticesList = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1NoticesListData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1NoticesListResponses, unknown, ThrowOnError>({ url: '/api/v1/notices/list', ...options });

/**
 * 获取外部链接列表
 */
export const getApiV1ExternalLinksList = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ExternalLinksListData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ExternalLinksListResponses, unknown, ThrowOnError>({ url: '/api/v1/external-links/list', ...options });

/**
 * 获取关键词排行列表
 *
 * 获取按排名升序排列的关键词排名列表。 type: 0=默认 1=首页 2=详细页
 *
 */
export const getApiV1KeywordRankings = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1KeywordRankingsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1KeywordRankingsResponses, unknown, ThrowOnError>({ url: '/api/v1/keywordRankings/getRankings', ...options });

/**
 * 开奖视频列表
 *
 * 按彩种、年份分页返回开奖视频列表，数据来自 11852 同步表； 顶层 code/message 用现有规范，data 为 pager+recordList 与 11852 一致。
 *
 */
export const postApiV1LotteryVideoList = <ThrowOnError extends boolean = false>(options: Options<PostApiV1LotteryVideoListData, ThrowOnError>) => (options.client ?? client).post<PostApiV1LotteryVideoListResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/lottery/video/list',
    ...options
});

/**
 * 获取轮播图列表
 */
export const getApiV1BannersList = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1BannersListData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1BannersListResponses, unknown, ThrowOnError>({ url: '/api/v1/banners/list', ...options });

/**
 * 文章类型列表
 *
 * 返回文章类型列表及可选年份列表。 yearList 为可用年份的整数数组，用于年份下拉菜单。
 *
 */
export const getApiV1ArticleTypeList = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ArticleTypeListData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ArticleTypeListResponses, unknown, ThrowOnError>({ url: '/api/v1/articleType/list', ...options });

/**
 * 文章搜索（分页）
 *
 * 按类型ID和年份分页搜索文章列表
 */
export const getApiV1ArticleTypeSearch = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1ArticleTypeSearchData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1ArticleTypeSearchResponses, unknown, ThrowOnError>({ url: '/api/v1/articleType/search', ...options });

/**
 * 文章详情
 *
 * 根据文章 ID 获取单篇文章的完整数据
 */
export const getApiV1ArticleTypeDetail = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ArticleTypeDetailData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ArticleTypeDetailResponses, unknown, ThrowOnError>({ url: '/api/v1/articleType/detail', ...options });

/**
 * 作者的文章列表
 *
 * 按作者 ID 分页获取该作者发表的文章列表
 */
export const getApiV1ArticleTypeUser = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ArticleTypeUserData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ArticleTypeUserResponses, unknown, ThrowOnError>({ url: '/api/v1/articleType/user', ...options });

/**
 * 获取彩票年份列表
 *
 * 根据lotteryType获取对应的年份列表
 */
export const getApiV1BbLotteryYear = <ThrowOnError extends boolean = false>(options: Options<GetApiV1BbLotteryYearData, ThrowOnError>) => (options.client ?? client).get<GetApiV1BbLotteryYearResponses, unknown, ThrowOnError>({ url: '/api/v1/bb/lotteryYear', ...options });

/**
 * 获取开奖结果列表
 *
 * 根据lotteryType和year获取开奖结果列表
 */
export const getApiV1BbLotteryResult = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1BbLotteryResultData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1BbLotteryResultResponses, unknown, ThrowOnError>({ url: '/api/v1/bb/lotteryResult', ...options });

/**
 * 获取内容详情
 *
 * 根据lotteryType和period获取bb_content详情及投票结果
 */
export const getApiV1BbContent = <ThrowOnError extends boolean = false>(options: Options<GetApiV1BbContentData, ThrowOnError>) => (options.client ?? client).get<GetApiV1BbContentResponses, unknown, ThrowOnError>({ url: '/api/v1/bb/content', ...options });

/**
 * 幽默猜测年份列表
 */
export const getApiV1LotteryTk118H5GuessListYear = <ThrowOnError extends boolean = false>(options: Options<GetApiV1LotteryTk118H5GuessListYearData, ThrowOnError>) => (options.client ?? client).get<GetApiV1LotteryTk118H5GuessListYearResponses, unknown, ThrowOnError>({ url: '/api/v1/lottery/tk118/h5/guess/listYear', ...options });

/**
 * 幽默猜测期数列表
 */
export const getApiV1LotteryTk118H5GuessListPeriod = <ThrowOnError extends boolean = false>(options: Options<GetApiV1LotteryTk118H5GuessListPeriodData, ThrowOnError>) => (options.client ?? client).get<GetApiV1LotteryTk118H5GuessListPeriodResponses, unknown, ThrowOnError>({ url: '/api/v1/lottery/tk118/h5/guess/listPeriod', ...options });

/**
 * 幽默猜测详情
 */
export const getApiV1LotteryTk118H5GuessDetail = <ThrowOnError extends boolean = false>(options: Options<GetApiV1LotteryTk118H5GuessDetailData, ThrowOnError>) => (options.client ?? client).get<GetApiV1LotteryTk118H5GuessDetailResponses, unknown, ThrowOnError>({ url: '/api/v1/lottery/tk118/h5/guess/detail', ...options });

/**
 * 投票（幽默猜测/天线宝宝）
 *
 * type=8 幽默猜测，type=16 天线宝宝
 */
export const postApiV1BbVote = <ThrowOnError extends boolean = false>(options: Options<PostApiV1BbVoteData, ThrowOnError>) => (options.client ?? client).post<PostApiV1BbVoteResponses, unknown, ThrowOnError>({
    url: '/api/v1/bb/vote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 发表评论
 *
 * type/id 为业务对象；社区(1)/图库(5)/资料(6)/天线宝宝(7)/幽默猜测(8) 发一级评论须带 lottery_type=1|2； 回复带 comment_id，object 从父评论继承。
 *
 */
export const postApiV1Comment = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CommentData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CommentResponses, unknown, ThrowOnError>({
    url: '/api/v1/comment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 评论列表
 *
 * type、id 必填；parent_id 非 0 时拉该父评论下子楼；asc=true 正序
 */
export const getApiV1CommentList = <ThrowOnError extends boolean = false>(options: Options<GetApiV1CommentListData, ThrowOnError>) => (options.client ?? client).get<GetApiV1CommentListResponses, unknown, ThrowOnError>({ url: '/api/v1/comment/list', ...options });

/**
 * 跨业务热门评论（天线宝宝/幽默猜测）
 *
 * 按彩种获取跨业务热门评论，天线宝宝和幽默猜测页使用
 */
export const getApiV1CommentPopular = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1CommentPopularData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1CommentPopularResponses, unknown, ThrowOnError>({ url: '/api/v1/comment/popular', ...options });

/**
 * 单对象热门评论
 *
 * 需传 type、id，与 comment/popular（运营热门、跨业务）不同；data 直接返回评论数组
 */
export const getApiV1CommentHots = <ThrowOnError extends boolean = false>(options: Options<GetApiV1CommentHotsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1CommentHotsResponses, unknown, ThrowOnError>({ url: '/api/v1/comment/hots', ...options });

/**
 * 评论点赞/取消点赞
 *
 * 对评论进行点赞或取消点赞操作。如果已点赞则取消点赞，未点赞则添加点赞。 同时会将文章ID和类型写入 UserLike 表，用于「我的点赞」列表展示。
 *
 */
export const postApiV1CommentLike = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CommentLikeData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CommentLikeResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/comment/like',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 点赞/取消点赞
 */
export const postApiV1ObjectSupport = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ObjectSupportData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ObjectSupportResponses, unknown, ThrowOnError>({
    url: '/api/v1/object/support',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 六合论坛主帖点赞/取消点赞
 *
 * 六合论坛主帖（不是评论）的点赞接口。每次调用切换点赞状态： 已点赞 → 取消，未点赞 → 点赞。请求体仅需主帖 id。
 *
 */
export const postApiV1ForumCommentLike = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ForumCommentLikeData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ForumCommentLikeResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/forum/comment/like',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 内容收藏/取消收藏
 *
 * 收藏目标支持：3=天线宝宝，4=幽默猜测，5=六合图库图片。favorite=1 收藏，favorite=0 取消收藏。
 */
export const postApiV1ContentCollect = <ThrowOnError extends boolean = false>(options: Options<PostApiV1ContentCollectData, ThrowOnError>) => (options.client ?? client).post<PostApiV1ContentCollectResponses, unknown, ThrowOnError>({
    url: '/api/v1/content/collect',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 获取 OSS STS 临时凭证
 *
 * 前台直传 OSS 前获取临时访问凭证
 */
export const getApiV1AuthOssSts = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1AuthOssStsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1AuthOssStsResponses, unknown, ThrowOnError>({ url: '/api/v1/auth/oss_sts', ...options });

/**
 * 图形验证码
 *
 * 返回 captcha_id 与 base64 PNG 图片。测试环境可用 captcha_id=1, captcha_code=9527。
 */
export const getApiV1Captcha = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1CaptchaData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1CaptchaResponses, unknown, ThrowOnError>({ url: '/api/v1/captcha', ...options });

/**
 * 校验图形验证码
 *
 * 单独校验图形验证码是否正确。校验通过后该 captcha_id 立即失效， 不能再用于后续业务接口（注册/登录/发码等），调用方需要重新 GET /api/v1/captcha 获取新 captcha_id。 测试/本地环境可用 captcha_id=1、captcha_code=9527。
 *
 */
export const postApiV1CaptchaVerify = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CaptchaVerifyData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CaptchaVerifyResponses, unknown, ThrowOnError>({
    url: '/api/v1/captcha/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 注册前检查并发送验证码
 */
export const postApiV1CheckRegisterInfo = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CheckRegisterInfoData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CheckRegisterInfoResponses, unknown, ThrowOnError>({
    url: '/api/v1/check-register-info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 注册
 *
 * 注册成功后端直接下发登录态（token、refresh_token、nickname 等），前端可直接 setAuth， 无需再调 /api/v1/login。
 *
 */
export const postApiV1Register = <ThrowOnError extends boolean = false>(options: Options<PostApiV1RegisterData, ThrowOnError>) => (options.client ?? client).post<PostApiV1RegisterResponses, unknown, ThrowOnError>({
    url: '/api/v1/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 退出登录
 */
export const postApiV1Logout = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1LogoutData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1LogoutResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * 我的关注列表
 */
export const getApiV1UserFollowList = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserFollowListData, ThrowOnError>) => (options.client ?? client).get<GetApiV1UserFollowListResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/follow/list',
    ...options
});

/**
 * 我的粉丝列表
 */
export const getApiV1UserFan = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserFanData, ThrowOnError>) => (options.client ?? client).get<GetApiV1UserFanResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/fan',
    ...options
});

/**
 * 用户粉丝列表
 *
 * 查询指定用户的粉丝列表。传 `user_id` 时返回关注该用户的人； 不传时默认取当前登录用户。底层使用 user_follow 表。
 *
 */
export const getApiV1UserFollowers = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserFollowersData, ThrowOnError>) => (options.client ?? client).get<GetApiV1UserFollowersResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/followers',
    ...options
});

/**
 * 用户关注列表
 *
 * 查询指定用户的关注列表。传 `user_id` 时返回该用户关注的人； 不传时默认取当前登录用户。底层使用 user_follow 表。
 *
 */
export const getApiV1UserFollowings = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserFollowingsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1UserFollowingsResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/followings',
    ...options
});

/**
 * 粉丝排行榜（Top 149）
 *
 * 全站统一榜单，不分港彩/澳彩，按粉丝数倒序排序。
 * 登录时条目附带 is_followed 与 is_blocked_by_me；self 为当前用户名次（rank=0 表示未上榜）。
 *
 */
export const getApiV1FansRanking = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1FansRankingData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1FansRankingResponses, unknown, ThrowOnError>({ url: '/api/v1/fans-ranking', ...options });

/**
 * 拉黑用户
 *
 * 拉黑同时双向取消关注；幂等，重复拉黑不报错。
 */
export const postApiV1BlockAdd = <ThrowOnError extends boolean = false>(options: Options<PostApiV1BlockAddData, ThrowOnError>) => (options.client ?? client).post<PostApiV1BlockAddResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/block/add',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 取消拉黑
 *
 * 不会自动恢复关注关系，需用户主动重新关注。
 */
export const postApiV1BlockRemove = <ThrowOnError extends boolean = false>(options: Options<PostApiV1BlockRemoveData, ThrowOnError>) => (options.client ?? client).post<PostApiV1BlockRemoveResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/block/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 黑名单列表
 */
export const getApiV1BlockList = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1BlockListData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1BlockListResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/block/list',
    ...options
});

/**
 * 我的内容收藏列表
 */
export const getApiV1ContentCollectList = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ContentCollectListData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ContentCollectListResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/content/collect-list',
    ...options
});

/**
 * 我的评论列表
 *
 * 查询当前登录用户发表的所有评论（一级评论和回复）。
 * type 是前端类型枚举（与 user/like/list 同一套），不传或 0 表示返回全部。
 *
 */
export const getApiV1UserCommentList = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserCommentListData, ThrowOnError>) => (options.client ?? client).get<GetApiV1UserCommentListResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/comment/list',
    ...options
});

/**
 * 他人主页信息
 *
 * 返回 avatar、username、nickname、fanCount、publishCount、userTotalSupport、userTotalVisit、isFollowing
 */
export const getApiV1UserByIdProfile = <ThrowOnError extends boolean = false>(options: Options<GetApiV1UserByIdProfileData, ThrowOnError>) => (options.client ?? client).get<GetApiV1UserByIdProfileResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/{id}/profile',
    ...options
});

/**
 * 更新头像
 *
 * 登录用户更新自己的头像（传头像地址）
 */
export const postApiV1UserAvatar = <ThrowOnError extends boolean = false>(options: Options<PostApiV1UserAvatarData, ThrowOnError>) => (options.client ?? client).post<PostApiV1UserAvatarResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/avatar',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 更新昵称
 *
 * 登录用户更新自己的昵称，长度 2~10
 */
export const putApiV1UserNickname = <ThrowOnError extends boolean = false>(options: Options<PutApiV1UserNicknameData, ThrowOnError>) => (options.client ?? client).put<PutApiV1UserNicknameResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/nickname',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 校验旧密码
 */
export const postApiV1UserCheckPassword = <ThrowOnError extends boolean = false>(options: Options<PostApiV1UserCheckPasswordData, ThrowOnError>) => (options.client ?? client).post<PostApiV1UserCheckPasswordResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/check_password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 修改密码
 */
export const postApiV1UserModifyPassword = <ThrowOnError extends boolean = false>(options: Options<PostApiV1UserModifyPasswordData, ThrowOnError>) => (options.client ?? client).post<PostApiV1UserModifyPasswordResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/modify_password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 更换手机号-校验旧手机号
 */
export const postApiV1UserChangeBindPhoneCheckOld = <ThrowOnError extends boolean = false>(options: Options<PostApiV1UserChangeBindPhoneCheckOldData, ThrowOnError>) => (options.client ?? client).post<PostApiV1UserChangeBindPhoneCheckOldResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/change_bindPhone/check_old',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 更换手机号
 */
export const postApiV1UserChangeBindPhone = <ThrowOnError extends boolean = false>(options: Options<PostApiV1UserChangeBindPhoneData, ThrowOnError>) => (options.client ?? client).post<PostApiV1UserChangeBindPhoneResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/user/change_bindPhone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 通知列表
 */
export const getApiV1Notifications = <ThrowOnError extends boolean = false>(options: Options<GetApiV1NotificationsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1NotificationsResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/notifications',
    ...options
});

/**
 * 清除通知计数
 */
export const postApiV1DelNotifications = <ThrowOnError extends boolean = false>(options?: Options<PostApiV1DelNotificationsData, ThrowOnError>) => (options?.client ?? client).post<PostApiV1DelNotificationsResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/del-notifications',
    ...options
});

/**
 * 论坛帖子列表
 *
 * 按彩种、分类、排序、关键字分页返回论坛帖子列表。 category：0=全部，1=参赛帖，2=图解帖； sort：general=综合，quality=精华，likes=点赞，newest=最新； order：0=推荐（默认），1=热门，2=最新； tab：0=全部（默认），1=关注。
 *
 */
export const getApiV1CommunityList = <ThrowOnError extends boolean = false>(options: Options<GetApiV1CommunityListData, ThrowOnError>) => (options.client ?? client).get<GetApiV1CommunityListResponses, unknown, ThrowOnError>({ url: '/api/v1/community/list', ...options });

/**
 * 论坛帖子详情
 *
 * 按帖子 ID 返回完整详情（含参赛数据、作者、开奖号码等）
 */
export const getApiV1CommunityDetail = <ThrowOnError extends boolean = false>(options: Options<GetApiV1CommunityDetailData, ThrowOnError>) => (options.client ?? client).get<GetApiV1CommunityDetailResponses, unknown, ThrowOnError>({ url: '/api/v1/community/detail', ...options });

/**
 * 发布论坛帖子
 *
 * 发布六合论坛帖子，后端根据请求内容自动判定类型（写入 category，优先级 图解 > 参赛 > 普通）： - 传 suggest_id（联想接口返回的 tuku_images.id）→ 图解帖（category=2）；
 * 即便同时传了 compete_data，也按图解处理、compete_data 被忽略
 * - 未传有效 suggest_id 且传了 compete_data → 参赛帖（category=1），发布后不可编辑/删除 - 其它情况 → 普通帖（category=0）
 * 注意：标题是否含"图解"已不再影响 category，只看 suggest_id。
 * 图片落库： - 图解帖：按 suggest_id 反查到的 tuku_images.image 写入 picture.pictureUrl；
 * images 中其它图（剔除与联想图重复项）写入 picture_list
 * - 普通帖 / 参赛帖：picture 为 NULL，images 全部写入 picture_list
 * 参赛收窄规则（detail_list 内顺序）： - 特肖：三肖 → 二肖 → 一肖 → 一码 - 特码：12码 → 8码 → 4码 → 1码 - 平码：最多 8 个。任意步骤未选完也允许发布
 * 发布限制： - 每人每期（同彩种）最多 3 个主题贴 - 昵称须 ≥3 个汉字，不含数字字母 - 账号须注册满 24 小时
 *
 */
export const postApiV1CommunityForumPublish = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CommunityForumPublishData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CommunityForumPublishResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/community/forum-publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 论坛发帖前置检测
 *
 * 进入发帖弹窗 / 提交前调用，检测当前账号是否满足注册满 24 小时的硬门槛。 allow=true 可发帖；allow=false 时 wait_seconds 为剩余秒数，msg 为可直接展示的提示文案。 本接口只校验注册时长，不做昵称 / 禁言 / 期数限额等其它发帖校验； 后端 /api/v1/community/forum-publish 仍会完整校验。
 *
 */
export const getApiV1CommunityForumPublishCheck = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1CommunityForumPublishCheckData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1CommunityForumPublishCheckResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/community/forum-publish/check',
    ...options
});

/**
 * 发帖标题联想
 *
 * 按彩种 + 年份 + 期号 + 关键词在 tuku_images 上做模糊匹配，返回候选图列表，用于发帖弹窗的标题下拉。 用户选中后，前端把 image 写入 /api/v1/community/forum-publish 请求体的 images 数组； 标题保留"图解"二字即可让后端按图解帖（category=2）落库。 仅返回 tuku.status=1（上架）且 tuku_images.image 非空的图。
 *
 */
export const getApiV1CommunityForumPublishSuggest = <ThrowOnError extends boolean = false>(options: Options<GetApiV1CommunityForumPublishSuggestData, ThrowOnError>) => (options.client ?? client).get<GetApiV1CommunityForumPublishSuggestResponses, unknown, ThrowOnError>({ url: '/api/v1/community/forum-publish/suggest', ...options });

/**
 * 编辑论坛帖子
 *
 * 编辑自己已发布的论坛帖子。仅发帖人本人可编辑；参赛帖（category=1）不可编辑，仅普通帖 / 图解帖允许。 title / content 留空表示不修改；images 传空数组清空图片。
 *
 */
export const postApiV1CommunityForumEdit = <ThrowOnError extends boolean = false>(options: Options<PostApiV1CommunityForumEditData, ThrowOnError>) => (options.client ?? client).post<PostApiV1CommunityForumEditResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/community/forum-edit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 加载上期帖子内容
 *
 * 按彩种返回当前用户上一期发布的标题/正文，用于"加载上期内容"
 */
export const getApiV1CommunityLastContent = <ThrowOnError extends boolean = false>(options: Options<GetApiV1CommunityLastContentData, ThrowOnError>) => (options.client ?? client).get<GetApiV1CommunityLastContentResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/community/last-content',
    ...options
});

/**
 * 参赛类型列表
 *
 * 返回发帖"我要参赛"的主类型（特肖/特码/平码）及子类型配置
 */
export const getApiV1CompeteTypeList = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1CompeteTypeListData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1CompeteTypeListResponses, unknown, ThrowOnError>({ url: '/api/v1/compete-type/list', ...options });

/**
 * 获奖榜单·年份+期数下拉
 *
 * 论坛 - 获奖榜单页（§3.1）顶部「年份 Tab + 期数 Tab/下拉」数据来源。 返回当前彩种下所有已开奖期数（有神力数据产出的期），按年份分组、年份倒序、期数倒序。
 *
 */
export const getApiV1ForumAwardRankingYearPeriod = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ForumAwardRankingYearPeriodData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ForumAwardRankingYearPeriodResponses, unknown, ThrowOnError>({ url: '/api/v1/forum/award_ranking/year_period', ...options });

/**
 * 获奖榜单·8 张卡 Top10
 *
 * 论坛 - 获奖榜单页（§3.3）8 张分类卡片，每张卡返回 Top 10 中奖用户。
 * 卡片固定 8 张顺序：三肖中特 / 二肖中特 / 一肖中特 / 一码中特 / 12码中特 / 8码中特 / 4码中特 / 8码。
 *
 * 合并规则（后端已处理，前端直接展示）：
 * - 第 4 卡「一码中特」 = `tx_one_code` + `tm_1`
 * - 第 8 卡「8码」 = `flat_8_4` + `flat_8_3` + `flat_8_2`
 *
 * Top10 排序：中奖项数 DESC → 用户总神力 DESC → 昵称 ASC。
 *
 */
export const getApiV1ForumAwardRanking = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ForumAwardRankingData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ForumAwardRankingResponses, unknown, ThrowOnError>({ url: '/api/v1/forum/award_ranking', ...options });

/**
 * 获奖榜单·底部悬浮条
 *
 * 论坛 - 获奖榜单页（§3.5）底部固定悬浮条数据：当前登录用户头像、昵称、 以及本彩种累计上榜次数（即累计神力，= §6.1「我的神力」、= 总榜本人 power，三处口径一致）。 未登录时返回 `user_id=0`，前端应隐藏悬浮条。
 *
 */
export const getApiV1ForumAwardRankingFooter = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ForumAwardRankingFooterData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ForumAwardRankingFooterResponses, unknown, ThrowOnError>({ url: '/api/v1/forum/award_ranking/footer', ...options });

/**
 * 高手神力榜·月榜/总榜
 *
 * 论坛 - 高手神力榜页（§4）数据。按 `scope` 返回当月榜或历史累计总榜，
 * 各展示前 100 名。时区为北京时间 UTC+8。
 *
 * 时间字段：
 * - `scope=month` 返回 `countdown_seconds`（距下月 1 日 00:00 的剩余秒数）；`updated_at` 为 null
 * - `scope=total` 返回 `updated_at`（当日 00:00，格式 "YYYY-MM-DD HH:mm:ss"）；`countdown_seconds` 为 null
 *
 * 返回结构：
 * - `top3` 前 3 名
 * - `list` 第 4~100 名
 * - `self` 当前登录用户的排名；`rank=0` 表示「暂无排名」；未登录时 `self=null`
 *
 */
export const getApiV1ForumPowerRanking = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ForumPowerRankingData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ForumPowerRankingResponses, unknown, ThrowOnError>({ url: '/api/v1/forum/power_ranking', ...options });

/**
 * 我的高手神力
 *
 * 论坛 - 「我的高手神力」页（§6）数据。包含顶部概览（昵称/头像/关注/粉丝/总神力/注册天数）
 * 及每期获奖明细（分页，按期数倒序）。
 *
 * 一致性硬约束（issue §十 验收）：`total_power` 必须与
 * **获奖榜底部** `boards_count`、**总榜本人** `power` 三处值一致。
 *
 * 需要登录；未登录返回 401。
 *
 */
export const getApiV1ForumMyPower = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ForumMyPowerData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ForumMyPowerResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/forum/my_power',
    ...options
});

/**
 * 论坛广告位列表
 *
 * 论坛页顶部 `.info-box` 内「广告」竖向轮播数据。
 *
 * - `lottery_type` 不传 ⇒ 仅返回 `lottery_type=0` 全站广告
 * - `lottery_type=1` ⇒ 港彩论坛广告（`lottery_type IN (0,1)`）
 * - `lottery_type=2` ⇒ 澳彩论坛广告（`lottery_type IN (0,2)`）
 * - 后端强制 `status=2`（上架），排序 `sort ASC, id DESC`
 * - 列表为空时 `list=[]`，前端按 `list.length===0` 不渲染
 *
 */
export const getApiV1ForumBanners = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ForumBannersData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ForumBannersResponses, unknown, ThrowOnError>({ url: '/api/v1/forum/banners', ...options });

/**
 * 论坛公告列表
 *
 * 论坛页顶部 `.info-box` 内「公告」竖向轮播数据。
 *
 * - `lottery_type` 不传 ⇒ 仅返回 `lottery_type=0` 全站公告
 * - `lottery_type=1` ⇒ 港彩论坛公告（`lottery_type IN (0,1)`）
 * - `lottery_type=2` ⇒ 澳彩论坛公告（`lottery_type IN (0,2)`）
 * - 后端强制 `status=1`（启用），排序 `sort_order ASC, id DESC`
 * - 列表为空时 `list=[]`，前端按 `list.length===0` 不渲染
 *
 */
export const getApiV1ForumAnnouncements = <ThrowOnError extends boolean = false>(options: Options<GetApiV1ForumAnnouncementsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1ForumAnnouncementsResponses, unknown, ThrowOnError>({ url: '/api/v1/forum/announcements', ...options });

/**
 * 获取图片上传签名
 *
 * 返回预签名上传 URL 和最终访问 URL。 调用方需用 PUT 方法把文件 body 直传到 upload_url， 请求头须带 Content-Type 与响应 headers 中一致； 上传成功（HTTP 200）后，asset_url 即为该图片的访问地址。
 *
 */
export const postApiV1AssetUploadSign = <ThrowOnError extends boolean = false>(options: Options<PostApiV1AssetUploadSignData, ThrowOnError>) => (options.client ?? client).post<PostApiV1AssetUploadSignResponses, unknown, ThrowOnError>({
    url: '/api/v1/asset/upload-sign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 获取网站设置
 *
 * C 端启动时一次性拉取：网站名称 / Logo / 客服链接 / 底部栏按钮 1&2 名称与链接。
 * 后台未配置的字段返回空串。
 *
 */
export const getApiV1SiteConfig = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1SiteConfigData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1SiteConfigResponses, unknown, ThrowOnError>({ url: '/api/v1/site-config', ...options });

/**
 * 获取最新 APP 下载链接
 *
 * 返回当前平台下最新版 APP 的下载地址。无需登录态。
 * 服务端未配置版本时 download_link 为空字符串。
 *
 */
export const getApiV1AppDownloadLink = <ThrowOnError extends boolean = false>(options: Options<GetApiV1AppDownloadLinkData, ThrowOnError>) => (options.client ?? client).get<GetApiV1AppDownloadLinkResponses, unknown, ThrowOnError>({ url: '/api/v1/app/download-link', ...options });

/**
 * 高手之家玩法字典
 *
 * 返回 C 端展示的玩法列表（仅后台开启显示的玩法），按 sort 升序。
 */
export const getApiV1PredictionTypes = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PredictionTypesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PredictionTypesResponses, unknown, ThrowOnError>({ url: '/api/v1/prediction/types', ...options });

/**
 * 高手之家六大榜单
 *
 * board_type：0=第123名（按玩法分组返回 groups，总榜+每玩法前3） 1=连中榜 2=连错榜 3=高手榜 4=新手榜 5=关注榜（返回 list，按名次升序，≤100）。 prediction_type_id 仅 board 1-4 有效（不传=全局榜）。恒返回最新一期快照。
 *
 */
export const getApiV1PredictionBoards = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PredictionBoardsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PredictionBoardsResponses, unknown, ThrowOnError>({ url: '/api/v1/prediction/boards', ...options });

/**
 * 高手之家当期预测贴 feed
 *
 * 默认返回最新一期（未开奖期）的预测贴，按发布时间倒序分页；all=1 时为跨期时间流。
 */
export const getApiV1PredictionList = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PredictionListData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PredictionListResponses, unknown, ThrowOnError>({ url: '/api/v1/prediction/list', ...options });

/**
 * 高手单玩法历史明细
 *
 * 某用户某玩法的逐期历史预测（含命中/连中/回报率），按期倒序分页。
 */
export const getApiV1PredictionDetail = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PredictionDetailData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PredictionDetailResponses, unknown, ThrowOnError>({ url: '/api/v1/prediction/detail', ...options });

/**
 * 高手之家用户个人页
 *
 * 用户信息（昵称/头像/来自/粉丝/关注）+ 该用户跨玩法全部港/澳帖子，按期倒序分页。
 */
export const getApiV1PredictionUser = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PredictionUserData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PredictionUserResponses, unknown, ThrowOnError>({ url: '/api/v1/prediction/user', ...options });

/**
 * 高手之家「他的粉丝」
 *
 * 公开接口，无需登录。按目标用户 ID 查看其粉丝列表（高手之家展示口径，与个人页头部 fans_count 同源）。dev 实测响应 data={total,list[{user_id,nickname,avatar}]}。
 */
export const getApiV1PredictionUserFans = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PredictionUserFansData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PredictionUserFansResponses, unknown, ThrowOnError>({ url: '/api/v1/prediction/user/fans', ...options });

/**
 * 高手之家「他的关注」
 *
 * 公开接口，无需登录。按目标用户 ID 查看其关注列表（高手之家展示口径，与个人页头部 follow_count 同源）。dev 实测响应 data={total,list[{user_id,nickname,avatar}]}。
 */
export const getApiV1PredictionUserFollows = <ThrowOnError extends boolean = false>(options: Options<GetApiV1PredictionUserFollowsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1PredictionUserFollowsResponses, unknown, ThrowOnError>({ url: '/api/v1/prediction/user/follows', ...options });

/**
 * 高手之家「我的」
 *
 * 需登录。用户头（昵称/头像/来自/关注/粉丝/分彩种帖子数）+ 我的本站帖子列表。
 */
export const getApiV1PredictionMy = <ThrowOnError extends boolean = false>(options?: Options<GetApiV1PredictionMyData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1PredictionMyResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/prediction/my',
    ...options
});

/**
 * 高手之家撤回本站帖
 *
 * 需登录。仅未开奖的本站帖可撤回。
 */
export const deleteApiV1PredictionPost = <ThrowOnError extends boolean = false>(options: Options<DeleteApiV1PredictionPostData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1PredictionPostResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/prediction/post',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 高手之家本站发帖
 *
 * 需登录。发预测（选玩法+生肖/号码），自动归到当前未开奖期； 一人一玩法一期一帖，开奖前重发即覆盖修改。
 *
 */
export const postApiV1PredictionPost = <ThrowOnError extends boolean = false>(options: Options<PostApiV1PredictionPostData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PredictionPostResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/prediction/post',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 高手之家帖子点赞/取消点赞
 *
 * 需登录。按 prediction_id 去重，再次调用取消点赞。
 */
export const postApiV1PredictionThumbUp = <ThrowOnError extends boolean = false>(options: Options<PostApiV1PredictionThumbUpData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PredictionThumbUpResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/prediction/thumb-up',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 高手之家帖子分享计数 +1
 *
 * 需登录。
 */
export const postApiV1PredictionShare = <ThrowOnError extends boolean = false>(options: Options<PostApiV1PredictionShareData, ThrowOnError>) => (options.client ?? client).post<PostApiV1PredictionShareResponses, unknown, ThrowOnError>({
    security: [{ name: 'authorization', type: 'apiKey' }],
    url: '/api/v1/prediction/share',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
